module.exports = __webpack_public_path__ + "static/media/strawberry.89590c04.png";